import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/imgs/LOGO/inova-option-logo-branca.png'


const _hoisted_1 = { class: "container-menor mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("nav", { class: "navbar navbar-projeto navbar-expand-lg" }, [
      _createElementVNode("div", { class: "container-fluid d-flex justify-content-between align-items-center" }, [
        _createElementVNode("img", {
          class: "animate__animated animate__fadeIn logo-delay img-fluid logo",
          src: _imports_0,
          alt: "Inova Option"
        }),
        _createElementVNode("a", {
          href: "https://inovaoption.com/auth/login",
          class: "animate__animated animate__fadeIn btn-delay btn btn-entrar",
          type: "button"
        }, "Entrar")
      ])
    ], -1)
  ])))
}